module.exports = __webpack_public_path__ + "img/lm@2x.10295415.png";